export default {
  headline: 'Welcome',
  welcomeText: process.env.VUE_APP_WELCOME_TEXT_EN ||
  'to the learning management system of innovation mecom.'
}
